import { toast } from "sonner";
import axios from "./axios";

// Flag to prevent multiple logout calls
let isLoggingOut = false;

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("arena_xp_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const token = localStorage.getItem("arena_xp_token");
    const hasValidToken = token && token !== "null" && token !== null;

    // Only trigger logout if user has a token (is supposed to be authenticated)
    if (error.response?.status === 401 && hasValidToken && !isLoggingOut) {
      isLoggingOut = true;
      toast.error("Session expired. Please login again.");

      // Clear localStorage
      localStorage.removeItem("arena_xp_token");
      localStorage.removeItem("user");
      localStorage.removeItem("profile");
      localStorage.removeItem("signedUp");

      // Trigger storage event to notify UserContext
      window.dispatchEvent(
        new StorageEvent("storage", {
          key: "arena_xp_token",
          newValue: null,
          oldValue: token,
        })
      );

      setTimeout(() => {
        isLoggingOut = false;
        window.location.href = "/";
      }, 100);

      return Promise.resolve({
        data: null,
        status: 401,
        statusText: "Unauthorized",
        headers: {},
        config: error.config,
      });
    }

    return Promise.reject(error);
  }
);
